import { render, staticRenderFns } from "./CustomApps.vue?vue&type=template&id=a79d442e&scoped=true"
import script from "./CustomApps.vue?vue&type=script&lang=js"
export * from "./CustomApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79d442e",
  null
  
)

export default component.exports